
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { OrderLineCommissionModel } from './Entities.GormCrm.OrderLineCommission';
import { ProductVariantModel } from './Entities.GormCrm.ProductVariant';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class OrderLineModel extends Model<OrderLineModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'orderId', type: 'string' },
		{ name: 'quantity', type: 'number' },
		{ name: 'totalPrice', type: 'number' },
		{ name: 'startupAmount', type: 'number' },
		{ name: 'startupAmountExclFirstInvoice', type: 'number' },
		{ name: 'startupInstallments', type: 'number' },
		{ name: 'productVariantId', type: 'string' },
		{ name: 'parentLineId', type: 'string' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'string' },
		{ name: 'paymentInterval', type: 'number' },
		{ name: 'numberOfInstallments', type: 'number' },
		{ name: 'discount', type: 'number' },
		{ name: 'inverseParentLine', type: 'OrderLineModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'order', type: 'OrderModel', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'orderLineCommission', type: 'OrderLineCommissionModel', isHidden: true, isObject: true, new: () => { return new OrderLineCommissionModel }, properties: () => { return OrderLineCommissionModel.classProperties } },
		{ name: 'parentLine', type: 'OrderLineModel', isHidden: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'productVariant', type: 'ProductVariantModel', isHidden: true, isObject: true, new: () => { return new ProductVariantModel }, properties: () => { return ProductVariantModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'changeLogPrimaryRelationEntityId', type: 'string' },
		{ name: 'changeLogPrimaryRelationEntityType', type: 'string' },
		{ name: 'childLines', type: 'OrderLineModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'totalPriceWithDiscount', type: 'number' },
		{ name: 'productPlans', type: 'ProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public quantity: number;
	public totalPrice: number;
	public startupAmount?: number;
	public startupAmountExclFirstInvoice?: number;
	public startupInstallments?: number;
	public productVariantId?: string;
	public parentLineId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public paymentInterval: number;
	public numberOfInstallments?: number;
	public discount?: number;
	public inverseParentLine: OrderLineModel[];
	public order?: OrderModel;
	public orderLineCommission?: OrderLineCommissionModel;
	public parentLine?: OrderLineModel;
	public productVariant?: ProductVariantModel;
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public changeLogPrimaryRelationEntityId: string;
	public changeLogPrimaryRelationEntityType: string;
	public childLines: OrderLineModel[];
	public totalPriceWithDiscount: number;
	public productPlans: ProductPlanModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.quantity = 0;
		this.totalPrice = 0;
		this.startupAmount = undefined;
		this.startupAmountExclFirstInvoice = undefined;
		this.startupInstallments = undefined;
		this.productVariantId = undefined;
		this.parentLineId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.paymentInterval = 0;
		this.numberOfInstallments = undefined;
		this.discount = undefined;
		this.inverseParentLine = [];
		this.order = undefined;
		this.orderLineCommission = undefined;
		this.parentLine = undefined;
		this.productVariant = undefined;
		this.questionnaireQuestionReplies = [];
		this.changeLogPrimaryRelationEntityId = '';
		this.changeLogPrimaryRelationEntityType = '';
		this.childLines = [];
		this.totalPriceWithDiscount = 0;
		this.productPlans = [];
		
	}
	getProperties(){
		return OrderLineModel.classProperties;
	}
}

